<template>
  <AppContent :label="General.PROCESS_PAINEL">
    <b-tabs
      v-model="activeTab"
      class="block custom-padding tabs-mobile"
      :animated="false"
      role="tablist"
      expanded
      multiline
    >
      <b-tab-item :value="TABS.IN_ANALYSIS.value" role="tab">
        <template slot="header">
          <b-icon icon="clipboard-text" />
          <span class="tabs-title" data-cy="process-user">
            {{ TABS.IN_ANALYSIS.name }}
            <b-tag
              v-if="activeTab === TABS.IN_ANALYSIS.value"
              class="custom-label-fs"
              rounded
            >
              {{ processInAnalysis.count }}
            </b-tag>
          </span>
        </template>
        <ProcessesUser role="tabpanel" />
      </b-tab-item>

      <b-tab-item :value="TABS.DRAFTS.value" role="tab">
        <template slot="header">
          <b-icon icon="file" />
          <span class="tabs-title" data-cy="process-draft">
            {{ TABS.DRAFTS.name }}
            <b-tag
              v-if="activeTab === TABS.DRAFTS.value"
              class="custom-label-fs"
              rounded
            >
              {{ processDraft.count }}
            </b-tag>
          </span>
        </template>
        <ProcessesDrafts role="tabpanel" />
      </b-tab-item>

      <b-tab-item :value="TABS.FAVORITES.value" role="tab">
        <template slot="header">
          <b-icon icon="star" />
          <span class="tabs-title" data-cy="process-favorite">
            {{ TABS.FAVORITES.name }}
            <b-tag
              v-if="activeTab === TABS.FAVORITES.value"
              class="custom-label-fs"
              rounded
            >
              {{ processFavorite.count }}
            </b-tag>
          </span>
        </template>
        <ProcessesFavorites role="tabpanel" />
      </b-tab-item>

      <b-tab-item
        v-if="hasPermission(userPermissions['SECTOR_VIEW'])"
        :value="TABS.SECTOR.value"
        role="tab"
      >
        <template slot="header">
          <b-icon icon="inbox-multiple" />
          <span class="tabs-title" data-cy="process-sector">
            {{ TABS.SECTOR.name }}
            <b-tag
              v-if="activeTab === TABS.SECTOR.value"
              class="custom-label-fs"
              rounded
            >
              {{ processUnit.count }}
            </b-tag>
          </span>
        </template>
        <ProcessesInbox role="tabpanel" />
      </b-tab-item>

      <b-tab-item :value="TABS.PROCESSED.value" role="tab">
        <template slot="header">
          <b-icon icon="send" />
          <span class="tabs-title" data-cy="process-processed">
            {{ TABS.PROCESSED.name }}
            <b-tag
              v-if="activeTab === TABS.PROCESSED.value"
              class="custom-label-fs"
              rounded
            >
              {{ processProcessed.count }}
            </b-tag>
          </span>
        </template>
        <ProcessesProcessed role="tabpanel" />
      </b-tab-item>

      <b-tab-item :value="TABS.ARCHIVED.value" role="tab">
        <template slot="header">
          <b-icon icon="archive-arrow-down" />
          <span class="tabs-title" data-cy="process-archived">
            {{ TABS.ARCHIVED.name }}
            <b-tag
              v-if="activeTab === TABS.ARCHIVED.value"
              class="custom-label-fs"
              rounded
            >
              {{ processArchive.count }}
            </b-tag>
          </span>
        </template>
        <ProcessesArchive role="tabpanel" />
      </b-tab-item>
    </b-tabs>
  </AppContent>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";

import AppContent from "@/layout/AppContent";

import ProcessesUser from "@/views/App/ProcessesUser";
import ProcessesDrafts from "@/views/App/ProcessesDrafts";
import ProcessesFavorites from "@/views/App/ProcessesFavorites";
import ProcessesInbox from "@/views/App/ProcessesInbox";
import ProcessesProcessed from "@/views/App/ProcessesProcessed";
import ProcessesArchive from "@/views/App/ProcessesArchive";

import { App, General } from "@/utils/constants";
import {
  PROCESS_PANEL_TABS as TABS,
  PROCESS_DETAILS_TABS as PROCESS_TABS,
  USER_PERMISSIONS as userPermissions
} from "@/utils/enumerate";

export default {
  name: "ProcessPainel",

  components: {
    AppContent,
    ProcessesUser,
    ProcessesDrafts,
    ProcessesFavorites,
    ProcessesInbox,
    ProcessesProcessed,
    ProcessesArchive
  },

  data() {
    return {
      App,
      General,
      TABS,
      PROCESS_TABS,
      userPermissions,
      animated: false,
      expanded: true,
      multiline: true
    };
  },

  computed: {
    ...mapGetters({
      user: "getCurrentUser",
      getCurrentTab: "getCurrentTabProcessPanel",
      hasPermission: "hasPermission",
      processUnit: "getProcessListByCapacity",
      processDraft: "getDraftList",
      processArchive: "getArchiveList",
      processFavorite: "getFavoriteList",
      processProcessed: "getProcessedList",
      processInAnalysis: "getProcessListByUser"
    }),
    activeTab: {
      get() {
        return this.getCurrentTab.value;
      },
      set(value) {
        this.setCurrentTab(this.TABS[value].value);
      }
    }
  },

  watch: {
    activeTab: {
      handler() {
        this.setCurrentTab(this.activeTab);
      }
    }
  },

  mounted() {
    this.setCurrentTab(this.activeTab);
  },

  methods: {
    ...mapMutations({
      setCurrentTab: "setCurrentTabProcessPanel",
      setCurrentTabProcessDetails: "setCurrentTabProcessDetails"
    })
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.tabs-title {
  font-size: 1rem;
  font-weight: bold;
}

.custom-label-fs {
  font-size: 0.7rem;
}
</style>
